import { type ChartQueryParams } from '../../../hooks';
import { useFacultiesChartQuery } from './useFacultiesQuery';

export const useFacultiesChart = (params?: ChartQueryParams) => {
	const { data, isLoading, error } = useFacultiesChartQuery(params);

	return {
		nivoData: data?.data || null,
		isLoading,
		error,
	};
};
